import * as React from "react"

const AgreementAccessIMG = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} {...props}>
    <defs>
      <clipPath id="a">
        <path
          data-name="Rectangle 50287"
          transform="translate(48 112)"
          style={{
            stroke: "#707070",
            fill: "#4e5a6b",
          }}
          d="M0 0h22v22H0z"
        />
      </clipPath>
    </defs>
    <g
      data-name="Mask Group 6340"
      transform="translate(-48 -112)"
      style={{
        clipPath: "url(#a)",
      }}
    >
      <g data-name="My Units">
        <g data-name="Group 95290">
          <path
            data-name="Union 1"
            d="M7.9 16.5H0L1.478.632c0-.956 1.96-.543 2.924-.543h4.337c.964 0 2.019-.409 2.019.547L13.141 16.5Z"
            transform="translate(49.873 114.784)"
            style={{
              fill: "#78b1fe",
            }}
          />
          <path
            d="M4.035 4.978a.682.682 0 0 0-.1.01h-.8a.682.682 0 1 0 0 1.364h.227v8.683A1.583 1.583 0 0 0 2 16.579v5a.682.682 0 0 0 .682.682h12.727a.682.682 0 0 0 .682-.682v-5a1.583 1.583 0 0 0-1.364-1.545V6.352h.227a.682.682 0 1 0 0-1.364h-.8a.682.682 0 0 0-.221 0H4.157a.682.682 0 0 0-.123-.01Zm.692 1.373h8.636v9.319a.682.682 0 0 0 .682.682h.455a.217.217 0 0 1 .227.227V20.9h-4.545v-2.73a.455.455 0 0 0-.455-.455H8.364a.455.455 0 0 0-.455.455v2.73H3.364v-4.321a.217.217 0 0 1 .227-.227h.455a.682.682 0 0 0 .682-.682ZM7 8.17a.455.455 0 0 0-.455.455v.909A.455.455 0 0 0 7 9.988h.909a.455.455 0 0 0 .455-.455v-.908a.455.455 0 0 0-.455-.455Zm3.182 0a.455.455 0 0 0-.455.455v.909a.455.455 0 0 0 .455.455h.909a.455.455 0 0 0 .455-.455v-.909a.455.455 0 0 0-.455-.455Zm5.455 0v1.364H19.5a1.137 1.137 0 0 1 1.136 1.136V20.9H17v.909a1.346 1.346 0 0 1-.083.455h4.4a.681.681 0 0 0 .683-.685V10.67a2.5 2.5 0 0 0-2.5-2.5ZM7 11.352a.455.455 0 0 0-.455.455v.909A.455.455 0 0 0 7 13.17h.909a.455.455 0 0 0 .455-.455v-.909a.455.455 0 0 0-.455-.455Zm3.182 0a.455.455 0 0 0-.455.455v.909a.455.455 0 0 0 .455.455h.909a.455.455 0 0 0 .455-.455v-.909a.455.455 0 0 0-.455-.455Zm7.727 0a.455.455 0 0 0-.455.455v.909a.455.455 0 0 0 .455.455h.909a.455.455 0 0 0 .455-.455v-.909a.455.455 0 0 0-.455-.455ZM7 14.534a.455.455 0 0 0-.455.455v.911a.455.455 0 0 0 .455.452h.909a.455.455 0 0 0 .455-.455v-.909a.455.455 0 0 0-.455-.455Zm3.182 0a.455.455 0 0 0-.455.455v.911a.455.455 0 0 0 .455.455h.909a.455.455 0 0 0 .455-.455v-.909a.455.455 0 0 0-.455-.455Zm7.727 0a.455.455 0 0 0-.455.455v.911a.455.455 0 0 0 .455.455h.909a.455.455 0 0 0 .455-.455v-.909a.455.455 0 0 0-.455-.455ZM5.182 17.715a.455.455 0 0 0-.455.455v.909a.455.455 0 0 0 .455.455h.909a.455.455 0 0 0 .455-.455v-.909a.455.455 0 0 0-.455-.455Zm6.818 0a.455.455 0 0 0-.455.455v.909a.455.455 0 0 0 .455.455h.909a.455.455 0 0 0 .455-.455v-.909a.455.455 0 0 0-.455-.455Zm5.909 0a.455.455 0 0 0-.455.455v.909a.455.455 0 0 0 .455.455h.909a.455.455 0 0 0 .455-.455v-.909a.455.455 0 0 0-.455-.455Z"
            transform="translate(47 109.02)"
            style={{
              fill: "#4e5a6b",
            }}
          />
        </g>
      </g>
    </g>
  </svg>
)

export default AgreementAccessIMG
